import type { RsPlusSceneSelectionUpgradeModal as RsPlusSceneSelectionUpgradeModalContent } from '@VelocitySquared/sunny16-content-dataobjects-cady/booking'

export type { RsPlusSceneSelectionUpgradeModalContent }

export const rsPlusUpgradeToStudioModalFallback: RsPlusSceneSelectionUpgradeModalContent = {
  internalName: '',
  badgeLabel: '',
  heading: '',
  subheading: '',
  bullets: '',
  footnote: '',
  bulletIcon: '',
  bulletIconColor: '',
  footnoteIcon: '',
  confirmLabel: '',
  confirmIcon: '',
  dismissLabel: '',
  dismissIcon: '',
  mobileConfirmLabel: '',
  mobileDismissLabel: '',
  images: []
}

export const rsPlusCaptureOneMoreModalFallback: RsPlusSceneSelectionUpgradeModalContent = {
  internalName: '',
  badgeLabel: '',
  heading: '',
  subheading: '',
  bullets: '',
  footnote: '',
  bulletIcon: '',
  bulletIconColor: '',
  footnoteIcon: '',
  confirmLabel: '',
  confirmIcon: '',
  dismissLabel: '',
  dismissIcon: '',
  mobileConfirmLabel: '',
  mobileDismissLabel: '',
  images: []
}

export const rsPlusFreeDigitalModalFallback: RsPlusSceneSelectionUpgradeModalContent = {
  internalName: '',
  badgeLabel: '',
  heading: '',
  subheading: '',
  bullets: '',
  footnote: '',
  bulletIcon: '',
  bulletIconColor: '',
  footnoteIcon: '',
  confirmLabel: '',
  confirmIcon: '',
  dismissLabel: '',
  dismissIcon: '',
  mobileConfirmLabel: '',
  mobileDismissLabel: '',
  images: []
}
